import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
	colors,
} from '@mui/material';

import ModalDialog from '../../../../../../components/ModalDialog/ModalDialog.js';
import AddOperatorForm from './components/AddOperatorForm/AddOperatorForm.js';
import { CreateOperator } from '../../../../actions/OperatorsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const AddOperatorDialog = (props) => {
	const { open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const formState = useSelector((state) => state.operatorsReducer.formState);
	const title = 'Add operator';

	const _onConfirmClick = () => {
		if (formState.isValid) {
			dispatch(CreateOperator(formState.values));
		}
	};

	const getData = useCallback(() => {
	}, []);

	useEffect(() => {
	}, []);

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title={title}
			confirmLabel="Save"
			onConfirmClicked={_onConfirmClick}
		>
			<AddOperatorForm />
		</ModalDialog>
	);
};

AddOperatorDialog.propTypes = {
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default AddOperatorDialog;
